import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { EvaluateOutcomesComponent } from './evaluate-outcomes.component';
import { OutcomeComponent } from './components/outcome/outcome.component';
import { RouterModule } from '@angular/router';
import { RequestComponent } from './components/request/request.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReportComponent } from './components/report/report.component';

@NgModule({
  declarations: [EvaluateOutcomesComponent, OutcomeComponent, RequestComponent, ReportComponent ],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    RouterModule.forChild([
      { path: 'evaluate-outcomes', component: EvaluateOutcomesComponent },
      { path: 'report', component: ReportComponent }
    ]),
  ]
})
export class EvaluateOutcomesModule { }
